import { styled } from '@innowise-group/mui-kit';
import { CircularProgress } from '@mui/material';

export const Loader = styled(CircularProgress)`
  margin: 60px auto;
  &.MuiCircularProgress-root {
    color: ${({ theme }) => theme.palette.general.smart};
  }
`;
